import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

export const PageHeading: React.FC = () => {
	return (
		<div className="text-typography-strong space-y-2 pt-6 md:pt-10">
			<Text className="text-typography-weak">
				<Translate value="corgi.topic_page_sitemap.page_heading.subtitle" />
			</Text>

			<Text as="h1" variant="heading" size="x-large">
				<Translate value="corgi.topic_page_sitemap.page_heading.title" />
			</Text>
		</div>
	);
};
